import { render, staticRenderFns } from "./LivestockHeader.vue?vue&type=template&id=5b1be499&scoped=true&"
import script from "./LivestockHeader.vue?vue&type=script&lang=js&"
export * from "./LivestockHeader.vue?vue&type=script&lang=js&"
import style0 from "./LivestockHeader.vue?vue&type=style&index=0&id=5b1be499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1be499",
  null
  
)

export default component.exports